import React, { useState } from "react";
import { observer } from "mobx-react";
import Play from "../Icons/Play.svg";
import Pause from "../Icons/Pause.svg";
import Logo from "../../../logo-no-text.png";
import LazyLoad from "react-lazyload";
import "../index.scss";
import { KeyboardArrowDown } from '@mui/icons-material';
import { Menu, MenuItem, Tooltip } from '@mui/material';
import userStore from '../../../Stores/User';
import { isPaidProUser } from '../../../constants/plans';

const getHostName = (link) => {
  if (link) {
    const doc = document.createElement("a");
    doc.href = (link.startsWith("http") ? "" : "http://") + link;
    return doc.hostname;
  }
};

const estimatedMinutes = (numCharacters) =>
  Math.round(((numCharacters / 36000) * 60) / 2);

const Article = observer(({ article, selectArticle, isActive, onVoiceChange }) => {
  const {
    article_id,
    title,
    date,
    date_added,
    num_characters,
    thumbnail_url,
    voice = 'Matthew', // Default voice
  } = article;

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  
  const isProUser = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id 
    ? isPaidProUser(userStore.user)
    : false;

  const handleVoiceClick = (event) => {
    if (isProUser) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleVoiceClose = () => {
    setAnchorEl(null);
  };

  const handleVoiceSelect = (newVoice) => {
    if (isProUser && onVoiceChange) {
      onVoiceChange(article_id, newVoice);
    }
    handleVoiceClose();
  };

  const articleDate = new Date(date || date_added);
  const [isHovering, setIsHovering] = useState(true);
  const [imageLoaded, setImageLoaded] = useState(false);

  const onImageLoaded = () => setImageLoaded(true);

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const availableVoices = [
    'Matthew', 'Joanna', 'Stephen', 'Olivia', 
    'Amy', 'Emma', 'Brian', 'Arthur'
  ];

  const voiceSelector = (
    <div className="voice-selector">
      <span className="voice-name">{voice}</span>
      <Tooltip title={isProUser ? "Change voice" : "Upgrade to Pro to change voices"}>
        <KeyboardArrowDown 
          className={`voice-arrow ${isProUser ? 'clickable' : ''}`}
          onClick={handleVoiceClick}
        />
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleVoiceClose}
      >
        {availableVoices.map((v) => (
          <MenuItem 
            key={v} 
            onClick={() => handleVoiceSelect(v)}
            selected={v === voice}
          >
            {v}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );

  return (
    <div className="article-card">
      <div
        className="article-background-img"
        style={{
          backgroundImage: `url(${imageLoaded ? thumbnail_url : Logo})`,
        }}
      />
      <div className="article">
        <div className="thumbnail" onClick={() => selectArticle(article)}>
          {thumbnail_url ? (
            <LazyLoad height={145} offset={150}>
              <img src={thumbnail_url} onLoad={onImageLoaded} />
            </LazyLoad>
          ) : null}
          <div
            style={{
              opacity: isHovering ? 1 : 0,
            }}
            className="floating-play-icon-container"
            onClick={() => selectArticle(article)}
          >
            <img id="floating-play-icon-svg" src={isActive ? Pause : Play} />
          </div>
        </div>
        <div className="title-container">
          <div className="title" onClick={() => selectArticle(article)}>
            {title}
          </div>
          {/* {voiceSelector} */}
        </div>
        <div className="author">
          <a href={`http://${article_id}`} target="_blank" className="link">
            {getHostName(article_id)}
          </a>
          <span className="divider">|</span>{" "}
          {monthNames[articleDate.getMonth()]} {articleDate.getFullYear()}
        </div>
        <div className="time">{estimatedMinutes(num_characters)} min</div>
      </div>
    </div>
  );
});

export default Article;
